var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-overlay bg-light"},[_c('div',{staticClass:"my-4"},[_c('BSpinner',{staticClass:"mr-3"})],1),_vm._v(" "+_vm._s(_vm.$gettext("Please wait while we logging you into the employer account."))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }